import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";

import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const HistoryPayment = Loadable({
  loader: () => import("~/components/desktop/pages/HistoryPayment"),
  loading: LoadableLoading
});

class DetectHistoryPayment extends Component {
  methods = {
    handleGoBack: () => {
      const { history } = this.props;
      history.push("/");
    }
  };

  render() {
    return (
      <React.Fragment>
        <HistoryPayment {...this.props} {...this.methods} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    fee: { listHistoryPayment }
  } = state;
  return {
    device: type,
    listHistoryPayment
  };
};

const HistoryPaymentHelmet = withTitle({
  component: DetectHistoryPayment,
  title: `${hospitalName.value} | Lịch sử thanh toán viện phí`
});

export default connect(mapStateToProps)(HistoryPaymentHelmet);
